import {RemoteGetContactData} from 'data/usecases';
import {GetContactData} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {ProfileChangeDataEndpoints} from 'main/factories/usecases/endpoints';

export const makeGetContactData = (): GetContactData =>
	new RemoteGetContactData(
		makeBFFApiUrl(ProfileChangeDataEndpoints.contactsData),
		makeAuthorizeHttpClientDecorator(),
	);
